import React from 'react';
import { alpha } from '@mui/material/styles';
import { Box, Container, IconButton, Link, Stack, Tooltip, Typography } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: 1,
        borderColor: (theme) => alpha(theme.palette.text.secondary, 0.18),
        py: 2,
        bgcolor: 'background.paper',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', md: 'space-between' },
            flexDirection: { xs: 'column', md: 'row' },
            flexWrap: { xs: 'nowrap', md: 'wrap' },
            rowGap: 1,
            columnGap: 2,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: { xs: '0.8rem', md: '0.875rem' }, whiteSpace: { md: 'nowrap' } }}
          >
            © {new Date().getFullYear()} Turbinas Maracaibo.
          </Typography>

          <Stack direction="row" spacing={0.25} alignItems="center" sx={{ flexShrink: 0 }}>
            <Tooltip title="Facebook">
              <IconButton
                aria-label="Facebook"
                component="a"
                href="https://facebook.com/turbinasmaracaibo"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{
                  color: (theme) => alpha(theme.palette.text.secondary, 0.75),
                  transition: 'color 150ms ease',
                  '&:hover': { color: 'text.primary' },
                  '& svg': { fontSize: 18 },
                }}
              >
                <FacebookIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Instagram">
              <IconButton
                aria-label="Instagram"
                component="a"
                href="https://instagram.com/turbinasmaracaibo"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{
                  color: (theme) => alpha(theme.palette.text.secondary, 0.75),
                  transition: 'color 150ms ease',
                  '&:hover': { color: 'text.primary' },
                  '& svg': { fontSize: 18 },
                }}
              >
                <InstagramIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="WhatsApp">
              <IconButton
                aria-label="WhatsApp"
                component="a"
                href="https://wa.me/584246383996"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{
                  color: (theme) => alpha(theme.palette.text.secondary, 0.75),
                  transition: 'color 150ms ease',
                  '&:hover': { color: 'text.primary' },
                  '& svg': { fontSize: 18 },
                }}
              >
                <WhatsAppIcon />
              </IconButton>
            </Tooltip>
          </Stack>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent={{ xs: 'center', md: 'flex-end' }}
            sx={{
              flexWrap: 'wrap',
              rowGap: 0.5,
              columnGap: 1,
              color: (theme) => alpha(theme.palette.text.secondary, 0.9),
              '& > *': { lineHeight: 1.2 },
            }}
          >

            <Stack direction="row" spacing={0.75} alignItems="center" sx={{ whiteSpace: { md: 'nowrap' } }}>
              <Box
                component="img"
                src="/media/kanga.png"
                alt="KaNG Developments"
                loading="lazy"
                decoding="async"
                sx={{ height: 14, width: 14, objectFit: 'contain', opacity: 0.8 }}
              />
              <Typography variant="caption" sx={{ color: 'inherit' }}>
                KaNG Developments
              </Typography>
              <Box component="span" sx={{ color: (theme) => alpha(theme.palette.text.secondary, 0.35) }}>
                •
              </Box>
              <Typography variant="caption" sx={{ color: 'inherit' }}>
                <Link
                  href="tel:+584149630979"
                  underline="none"
                  sx={{
                    color: 'inherit',
                    transition: 'color 150ms ease',
                    '&:hover': { color: 'text.primary' },
                  }}
                >
                  +58 414-9630979
                </Link>
              </Typography>

              <Box component="span" sx={{ color: (theme) => alpha(theme.palette.text.secondary, 0.35) }}>
                •
              </Box>

              <Typography variant="caption" sx={{ color: 'inherit' }}>
                <Link
                  href="mailto:ramoskangaroo@gmail.com"
                  underline="none"
                  sx={{
                    color: 'inherit',
                    transition: 'color 150ms ease',
                    '&:hover': { color: 'text.primary' },
                  }}
                >
                  ramoskangaroo@gmail.com
                </Link>
              </Typography>

            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
